import { updateMetaTags } from '../../utils/meta-tags-updater';
import { useEffect, useState } from "react";
import { Box, CardMedia, Container, Grid, Stack, Typography } from "@mui/material";
import Card from '../card/Card';
import MusicPlayer from "../player/MusicPlayer"
import { encrypt, getServiceToken } from '../../utils/encryption';
import { API } from '../../interceptors/axios';
import { useNavigate, useParams } from "react-router-dom";
import { fetchAuth } from '../../utils/auth';
import ThemeAmbientOverlay from '../theme-ambient-overlay/ThemeAmbientOverlay';
import { useTheme } from '../../theme/theme-provider';
import './Details.css';
// import { isSocialMediaPreview, getSocialPlatform } from '../../utils/social-media-detector';



const Details = ({sendPage}) => {
  const { themeMode } = useTheme();
  const navigate = useNavigate();

  // const [songId, setSongId] = useState(0)
  const [songUrl, setSongUrl] = useState([])  
  const [imageUrl, setImageUrl] = useState()
  const [blogData, setBlogData] = useState([])
  const [smallImageUrl, setSmallImageUrl] = useState(); // Add this line
  const [isLoading, setLoading] = useState(true)
  const [relatedSongs, setRelatedSongs] = useState([])

  let {slug} = useParams('')

  // Get these values immediately, don't wait for useEffect
  const slugParts = typeof slug === 'string' ? slug.split('-') : [];
  const songId = slugParts.length ? slugParts[slugParts.length - 1] : '';
  const songTitle = slugParts.length > 1 ? slugParts.slice(0, -1).join('-') : '';
  
  // Pre-set meta tags immediately for crawlers
  // if (typeof window !== 'undefined' && isSocialMediaPreview()) {
  //   console.log("Pre-setting meta tags for details page crawler");
  //   const platform = getSocialPlatform();
  //   const publicPreviewUrl = `${process.env.REACT_APP_API_URL}/public-preview/${songId}.jpg?v=${Date.now()}`;
    
  //   updateMetaTags({
  //     title: 'Distorise Music - ' + songTitle.replace(/-/g, ' '),
  //     description: 'Listen to this track on Distorise Music Blog',
  //     imageUrl: publicPreviewUrl,
  //     pageUrl: window.location.href,
  //     type: 'music.song'
  //   });
    
  //   console.log(`Bot meta tags pre-set for ${platform || 'unknown'} with URL: ${publicPreviewUrl}`);
  // }


  const buildStreamUrl = async (songId) => {
      const tokenRes = await API.get(
          `${process.env.REACT_APP_API_URL}/stream-token/${songId}`,
          { withCredentials: true }
      );
      const streamToken = tokenRes.data.token;
      const url = new URL(`${process.env.REACT_APP_API_URL}/stream-audio/${songId}`);
      url.searchParams.set('token', streamToken);
      url.searchParams.set('x-service-token', getServiceToken());
      return { url: url.toString(), headers: { 'Accept': 'audio/mpeg' } };
  };


  useEffect(() => {
    sendPage("details");
    window.scrollTo(0, 0);

    const invalidSlug =
      !slug ||
      slug === 'undefined' ||
      slug === 'null' ||
      slug.split('-').some((part) => part === 'undefined' || part === 'null' || part === '');

    if (invalidSlug) {
      setLoading(false);
      navigate('/not-found', { replace: true });
      return;
    }

    // Set links style
    const style = document.createElement('style');
    style.textContent = `
      .platform-link {
        -webkit-tap-highlight-color: transparent;
        display: inline-block;
        background-color: rgba(0, 0, 0, 0.9);
        opacity: 0.8;
        border-radius: 10px;
        padding: 14px 24px;
        width: 100%;
        text-align: center;
        transition: transform 0.2s ease, background-color 0.2s ease;
      }
      
      .platform-link:active {
        transform: scale(0.98);
        background-color: rgba(40, 40, 40, 0.9) !important;
      }
      
      @media (max-width: 767px) {
        .platform-link {
          padding: 16px 20px;
        }
      }
    `;
    document.head.appendChild(style);
    
    const fetchSongsData = async () => {
      try {        
        setLoading(true);
        await fetchAuth();

        if (typeof slug == 'undefined') {
          setLoading(false);
          return;
        }

        const token = localStorage.getItem("token")

        // Get blog data in a single request
        const blog_data = await API.get(
          `${process.env.REACT_APP_API_URL}/blogs/${songTitle}`,
          { headers: { 'Authorization': `Bearer ${token}` } }
        );

        if (blog_data && blog_data.data) {
          const data = blog_data.data;
          setBlogData(data);
        }

        // Continue with audio and image loading
        if (blog_data.data.song) {
          const songId = blog_data.data.song;
          const streamUrl = await buildStreamUrl(songId);
          setSongUrl(streamUrl);
          const publicImageUrl = `${process.env.REACT_APP_API_URL}/public-image/${songId}`;
          setImageUrl(publicImageUrl);
          setSmallImageUrl(publicImageUrl);
        }
        
        setLoading(false);
        
        // Fetch related songs AFTER main content is shown — non-blocking, runs independently
        const token2 = localStorage.getItem("token");
        API.get('/songs/', { headers: { 'Authorization': `Bearer ${token2}` } })
          .then(songs_response => {
            if (Array.isArray(songs_response.data)) {
              setRelatedSongs(
                songs_response.data
                  .filter(s =>
                    String(s.id) !== String(songId) &&
                    s.id != null && String(s.id) !== 'undefined' &&
                    s.slug != null && typeof s.slug === 'string' &&
                    s.slug !== 'undefined' && s.slug !== 'null' && s.slug.trim() !== ''
                  )
                  .slice(0, 4)
              );
            }
          })
          .catch(() => {});
      } catch (error) {
        console.error("Error fetching song data:", error);
        setLoading(false);
      }
    }

    fetchSongsData()    

    const handleContextmenu = e => {
      e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        updateMetaTags(); // Reset to defaults
        document.removeEventListener('contextmenu', handleContextmenu)
        document.head.removeChild(style);
    }
  }, [slug, navigate])

  return (
  <Box className="DetailsImageMotion" sx={{
        backgroundColor: 'var(--background-color)',
        backgroundImage: `url(${imageUrl})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed', // This makes it a fixed wallpaper
        width: "100%",
        minHeight: '100vh', // Ensure it covers full viewport height
        justifyContent: "center",
        position: 'relative',
        '&::before': { // Add overlay to make content more readable
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: themeMode === 'dark'
            ? 'rgba(0, 0, 0, 0.56)'
            : 'rgba(245, 240, 234, 0.78)',
          zIndex: 1
        }
      }}>

      <ThemeAmbientOverlay speed={30} />

      <Box sx={{ position: 'relative', zIndex: 2 }}>
      <Box
        sx={{
          height: '160px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: { xs: 2, sm: 3, md: 4 },
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            height: { xs: '86px', sm: '96px', md: '104px' },
            background: themeMode === 'dark'
              ? 'linear-gradient(90deg, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.62) 14%, rgba(0,0,0,0.78) 50%, rgba(0,0,0,0.62) 86%, rgba(0,0,0,0.02) 100%)'
              : 'linear-gradient(90deg, rgba(255,250,244,0.02) 0%, rgba(255,250,244,0.72) 14%, rgba(255,250,244,0.9) 50%, rgba(255,250,244,0.72) 86%, rgba(255,250,244,0.02) 100%)',
            pointerEvents: 'none',
          }
        }}
      >
        <Typography
          align="center"
          color={themeMode === 'dark' ? 'white' : 'rgba(22,22,22,0.96)'}
          variant="h2"
          sx={{ 
            fontWeight: 900,
            position: 'relative',
            zIndex: 1,
            fontFamily: 'Light-1',
            fontSize: { 
              xs: '1.75rem',
              sm: '2.25rem',
              md: '2.75rem',
              lg: '3rem'
            },
            wordBreak: 'break-word',
            lineHeight: { xs: 1.3, md: 1.2 },
            maxWidth: '100%',
            px: { xs: 1, sm: 2 },
            transition: 'font-size 0.3s',
            textShadow: themeMode === 'dark'
              ? '0 3px 14px rgba(0,0,0,0.78)'
              : '0 1px 0 rgba(255,255,255,0.72)'
          }}
        >
          {blogData.title}
        </Typography>
      </Box>

      {/* Metadata row */}
      {(blogData.release_type || blogData.year || blogData.bpm || blogData.genre) && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', pb: 1.5 }}>
          {[
            blogData.release_type,
            blogData.year,
            blogData.bpm ? `${blogData.bpm} BPM` : null,
            blogData.genre,
          ].filter(Boolean).map((item, i, arr) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography sx={{
                fontFamily: '"Courier New", monospace',
                fontSize: { xs: '0.72rem', sm: '0.78rem' },
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                fontWeight: 700,
                color: themeMode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.45)',
              }}>
                {item}
              </Typography>
              {i < arr.length - 1 && (
                <Typography sx={{ mx: 1, color: themeMode === 'dark' ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.25)', fontSize: '0.6rem' }}>
                  /
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      )}

      <Container sx={{width: '100%',}}>
      <hr style={{
         height: '12px',
         border: '0',
         width: '100%',
        boxShadow: 'inset 0 12px 12px -12px rgba(0, 0, 0, 0.5)'}}/>
      </Container>
      
      </Box>

        <MusicPlayer 
          song={songUrl} 
          isLoading={isLoading} 
          slug={slug.split('-').slice(0, -1).join('-')}
          songImage={smallImageUrl || imageUrl}
          songId={songId}
          refreshSong={songId ? async () => { await fetchAuth(); return buildStreamUrl(songId); } : undefined}
          />

      <Container maxWidth={false} sx={{ width: { xs: "94%", sm: "84%", md: "74%" }, maxWidth: 920, borderRadius: 0, px: 0 }}>
        <hr style={{ height: '4px', border: '0', width: '100%', boxShadow: 'inset 0 4px 6px -4px rgba(0,0,0,0.35)' }}/>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 1, sm: 2, md: 8 }}
          mt={1.5}
          sx={{ 
            position: 'relative', 
            zIndex: 2,
            width: '100%',
            maxWidth: '100%'
          }}>
          <Box 
            flex={3} 
            sx={{
              width: '100%',
              zIndex: 3
            }}>
          <CardMedia
            sx={{              
              height: "auto",
              width: "100%"
            }}>
                <Typography
                  component="div"
                  m={0}
                  variant="body2"
                  fontSize={{ xs: 13, sm: 15, md: 17 }}
                  sx={{ 
                    fontWeight: 800,
                    fontFamily: '"Courier New", monospace',
                    lineHeight: { xs: 1.7, md: 1.65 },
                    letterSpacing: '0.02em',
                    position: 'relative',
                    zIndex: 4,
                  }}>
                  <Box sx={{
                    borderRadius: '4px',
                    color: themeMode === 'dark' ? 'rgba(255,255,255,0.86)' : '#1a1a1a',
                    padding: { xs: '20px 20px', sm: '28px 32px', md: '32px 40px' },
                    textAlign: { xs: 'left', md: 'center' },
                    wordBreak: 'break-word',
                    overflowWrap: 'anywhere',
                    hyphens: 'auto',
                    background: themeMode === 'dark' ? 'rgba(0,0,0,0.80)' : 'rgba(252,248,244,0.95)',
                    backdropFilter: 'blur(14px)',
                    border: themeMode === 'dark'
                      ? '1px solid rgba(242, 211, 153, 0.25)'
                      : '1px solid rgba(0,0,0,0.10)',
                    boxShadow: themeMode === 'dark'
                      ? 'inset 0 1px 0 rgba(255,255,255,0.03), 0 8px 32px rgba(0,0,0,0.45)'
                      : '0 8px 24px rgba(0,0,0,0.08)',
                  }}>
                    {blogData.highlight ? (
                      <>
                        {blogData.content}{' '}
                        <span style={{ color: '#FF2200', fontWeight: 600 }}>{blogData.highlight}</span>
                      </>
                    ) : (() => {
                      const raw = blogData.content || '';
                      const sep = raw.lastIndexOf('|');
                      if (sep !== -1) {
                        return (
                          <>
                            {raw.slice(0, sep)}
                            <span style={{ color: '#FF2200', fontWeight: 600 }}>{raw.slice(sep + 1)}</span>
                          </>
                        );
                      }
                      return raw;
                    })()}
                  </Box>
                </Typography>
              
                {/* Platform Links Section */}
                {(blogData.bandcamp_link || blogData.spotify_link || blogData.soundcloud_link || blogData.apple_music_link || blogData.beatport_link || blogData.youtube_link) && (
                <Box sx={{
                  mt: 2,
                  mb: 2,
                  width: '100%',
                  background: themeMode === 'dark' ? 'rgba(0,0,0,0.80)' : 'rgba(252,248,244,0.96)',
                  backdropFilter: 'blur(14px)',
                  border: themeMode === 'dark' ? '1px solid rgba(242,211,153,0.25)' : '1px solid rgba(0,0,0,0.10)',
                  borderRadius: '4px',
                  padding: { xs: '16px 20px', sm: '20px 28px' },
                }}>
                  {/* Primary CTA — Bandcamp */}
                  {blogData.bandcamp_link && (
                    <Box sx={{ mb: 1.5 }}>
                      <a
                        href={blogData.bandcamp_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="platform-link"
                        style={{
                          textDecoration: 'none',
                          display: 'block',
                          padding: '14px 24px',
                          border: themeMode === 'dark' ? '1px solid #FF2200' : '1px solid rgba(0,0,0,0.85)',
                          borderRadius: '6px',
                          backgroundColor: themeMode === 'dark' ? 'transparent' : 'rgba(0,0,0,0.05)',
                          color: themeMode === 'dark' ? '#FF2200' : 'rgba(0,0,0,0.88)',
                          fontFamily: '"Courier New", monospace',
                          fontWeight: 'bold',
                          fontSize: '14px',
                          letterSpacing: '2px',
                          textTransform: 'uppercase',
                          textAlign: 'center',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.backgroundColor = themeMode === 'dark' ? '#FF2200' : 'rgba(0,0,0,0.88)';
                          e.currentTarget.style.color = themeMode === 'dark' ? '#000' : '#fff';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.backgroundColor = themeMode === 'dark' ? 'transparent' : 'rgba(0,0,0,0.05)';
                          e.currentTarget.style.color = themeMode === 'dark' ? '#FF2200' : 'rgba(0,0,0,0.88)';
                        }}
                        aria-label="Open Bandcamp"
                      >
                        &gt; BANDCAMP
                      </a>
                    </Box>
                  )}
                  {/* Secondary links — text slash row */}
                  {(() => {
                    const secondaryLinks = [
                      { id: 'spotify', link: blogData.spotify_link, label: 'SPOTIFY' },
                      { id: 'soundcloud', link: blogData.soundcloud_link, label: 'SOUNDCLOUD' },
                      { id: 'apple_music', link: blogData.apple_music_link, label: 'APPLE MUSIC' },
                      { id: 'beatport', link: blogData.beatport_link, label: 'BEATPORT' },
                      { id: 'youtube', link: blogData.youtube_link, label: 'YOUTUBE' },
                    ].filter(p => p.link);
                    if (!secondaryLinks.length) return null;
                    return (
                      <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center', mt: 1.5 }}>
                        {secondaryLinks.map(p => (
                          <Box key={p.id} sx={{ display: 'flex', alignItems: 'center' }}>
                            <a
                              href={p.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: 'none',
                                color: themeMode === 'dark' ? 'rgba(255,255,255,0.68)' : 'rgba(0,0,0,0.82)',
                                fontFamily: '"Courier New", monospace',
                                fontWeight: 700,
                                fontSize: '12px',
                                letterSpacing: '1.5px',
                                textTransform: 'uppercase',
                                padding: '4px 5px',
                                transition: 'color 0.15s ease',
                              }}
                              onMouseEnter={e => { e.currentTarget.style.color = themeMode === 'dark' ? '#fff' : '#000'; }}
                              onMouseLeave={e => { e.currentTarget.style.color = themeMode === 'dark' ? 'rgba(255,255,255,0.68)' : 'rgba(0,0,0,0.82)'; }}
                            >
                              {p.label}
                            </a>
                            <Typography sx={{ color: themeMode === 'dark' ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.55)', fontSize: '12px', mx: 0.25 }}>/</Typography>
                          </Box>
                        ))}
                      </Box>
                    );
                  })()}
                </Box>)}
          
          </CardMedia>
          </Box>
        </Stack>
      </Container>

      {/* CHECK THIS OUT TOO */}
      {relatedSongs.length > 0 && (
        <Container maxWidth={false} sx={{ width: { xs: '94%', sm: '84%', md: '74%' }, maxWidth: 920, pb: 3, pt: 0, mt: 2, position: 'relative', zIndex: 2, px: 0 }}>
          <Box sx={{
            background: themeMode === 'dark' ? 'rgba(0,0,0,0.80)' : 'rgba(252,248,244,0.96)',
            backdropFilter: 'blur(14px)',
            border: themeMode === 'dark' ? '1px solid rgba(242,211,153,0.25)' : '1px solid rgba(0,0,0,0.10)',
            borderRadius: '4px',
            padding: { xs: '16px', sm: '24px 28px' },
          }}>
          <Typography
            sx={{
              fontFamily: 'Light-1',
              fontWeight: 900,
              fontSize: { xs: '1rem', md: '1.15rem' },
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: themeMode === 'dark' ? 'rgba(255,255,255,0.88)' : 'rgba(0,0,0,0.82)',
              mb: 2,
              mt: 0,
              textAlign: 'center',
            }}
          >
            &gt; CHECK THIS OUT TOO
          </Typography>
          <Grid container spacing={2} alignItems="stretch">
            {relatedSongs.map(song => (
              <Grid item xs={6} sm={3} key={song.id} sx={{ display: 'flex' }}>
                <Card
                  cardImageId={song.id}
                  cardTitle={song.title}
                  cardSlug={song.slug}
                  cardMeta={[song.release_type, song.genre].filter(Boolean).join(' / ')}
                  compact
                />
              </Grid>
            ))}
          </Grid>
          </Box>
        </Container>
      )}

  </Box>
  );
};

export default Details;